module.exports = __webpack_public_path__ + "img/ielts-service.3906edae.jpg";